'use client';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { useStore } from 'zustand';

import { Button } from '@/components/ui/button/button.component';
import { professionalDisplayName } from '@/utils/formatters/professional-name';
import { userLocationStore } from '@/store/user-location.store';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { Link } from '@/components/ui/link/link.component';
import { useWhatsappLinkWithAnalytics } from '@/hooks/use-whatsapp/use-whatsapp-link-with-analytics.hook';
import { phonePatientSac } from '@/utils/consts/sac.consts';

interface WhatsappTabContentProps {
  schedule: SearchPartnerData;
  procedure: string;
  withTitle?: boolean;
}

export function WhatsappTabContent({ schedule, procedure, withTitle = true }: WhatsappTabContentProps) {
  const professional = professionalDisplayName(schedule?.professional);
  const userLocation = useStore(userLocationStore, (state) => state.userLocation);

  const { url } = useWhatsappLinkWithAnalytics(
    phonePatientSac.toString(),
    `Olá, gostaria de agendar ${procedure} em ${userLocation?.city} - ${userLocation?.state} com ${professional} com a Medprev.`,
  );
  return (
    <>
      {withTitle && <span className="text-xl text-gray-800 font-semibold">WhatsApp</span>}
      <div className="flex flex-col justify-between h-full">
        <p className="text-gray-800" data-test-id="title--whatsapp-tab-content">
          Para agendar pelo WhatsApp, é só clicar no botão abaixo e falar com o nosso time de atendimento.
          {' '}
        </p>

        <Button
          className="mt-3 h-10 py-2 text-base"
          startIcon={faWhatsapp}
          startIconSize="1x"
          startIconClassName="text-base"
          asChild
          data-testid={DataTestIdEnum.SEARCH_SCHEDULE_MODAL_WHATSAPP_TAB_CONTENT_BUTTON}
        >
          <Link prefetch={false} href={url} target="_blank" rel="noopener noreferrer">
            Agendar pelo WhatsApp
          </Link>
        </Button>
      </div>
    </>
  );
}
